import { DraggableArea } from "./base/DraggableArea";
import AuthenticatedSupportChat from "./chat/AuthenticatedSupportChat";

interface SupportAreaProps {
  onClose: () => void;
  title: string;
}

export function SupportArea({ onClose, title }: SupportAreaProps) {

  const supportContent = (
    <div className="areaChatParent">
      <AuthenticatedSupportChat hasProjectContext={ true } />      
    </div>
  );

  return (
    <DraggableArea 
      openIcon="wand-magic-sparkles"
      title={title}      
      content={ supportContent }
      onClose={onClose}
    />
  );
}
